// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__15GvN","notes":"Notes_notes__3ZMmA","note":"Notes_note__8KtTo","markdown":"Notes_markdown__2Zl5N"};